import React from 'react';
import { SettingsPage } from '../Settings';

export const MaintenanceSettings: React.FC = () => {
  return <SettingsPage />;
};

